module.exports = __webpack_public_path__ + "static/media/component-icon.19644c43.svg";